import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';

const CONTACTS_KEY = 'contacts';

export function useContacts(params = {}) {
  return useQuery({
    queryKey: [CONTACTS_KEY, params],
    queryFn: () => api.get('/contacts', { params }).then((r) => r.data),
    staleTime: 2 * 60 * 1000,
  });
}

export function useContact(id) {
  return useQuery({
    queryKey: [CONTACTS_KEY, id],
    queryFn: () => api.get(`/contacts/${id}`).then((r) => r.data),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreateContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post('/contacts', body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [CONTACTS_KEY] }),
  });
}

export function useUpdateContact(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.patch(`/contacts/${id}`, body).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [CONTACTS_KEY, id] });
      qc.invalidateQueries({ queryKey: [CONTACTS_KEY] });
    },
  });
}

export function useDeleteContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/contacts/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: [CONTACTS_KEY] }),
  });
}

export function useLinkContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post('/contacts/link', body).then((r) => r.data),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: [CONTACTS_KEY, { account_id: vars.account_id }] });
      qc.invalidateQueries({ queryKey: ['accounts', vars.account_id] });
    },
  });
}

export function useUnlinkContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ linkId }) => api.delete(`/contacts/link/${linkId}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [CONTACTS_KEY] });
      qc.invalidateQueries({ queryKey: ['accounts'] });
    },
  });
}
